/**
 * Black-Swan Plugin Core
 *
 * @since: 2017-11-23
 * @author: kdydesign.kim
 */

import Vue from 'vue'

// global plugins
import VueClipboard from 'vue-clipboard2'
import Quasar, * as All from 'quasar'
import VueDataTable from './dataTable/vue-data-table.esm.js'
import VueTable from './dataTable/vue-table.esm.js'
import VeeValidate from './validate' // TAMS
import worldMap from './worldMap/worldMap.js'
// TAMS plugins
import VueVirtualScroller from 'vue-virtual-scroller'

// Grid Layout Plugin
import './gridLayout/gridstack.js'
import GridLayout from './gridLayout'
import DragMenu from './dragMenuJQuery/dragMenu.js'
import Charts from '@secui/charts'

// plugin style
import 'jquery-ui'
import 'jquery-ui-css'
import 'flag-icon-css/css/flag-icon.css'
import '@secui/icons'
import 'quasar-extras/material-icons'
import 'quasar-extras/fontawesome'
import './gridLayout/layout.css'
import './dataTable/vue-table.esm.min.css'
import './zTree/zTree.css'
import '@secui/charts/dist/charts.css'
// TAMS plugin style
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

// polyfill
import {MouseEventPathPolyfill} from './mouseevent.path.polyfill'

// Support ie
if (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) {
  require('./quasar/quasar.ie.polyfills')
  // MouseEvent.path 주입
  MouseEventPathPolyfill()
  console.warn('IE Polyfills import. To late performance.')
}

// 새 창을 출력 후 window 에 주입
const newWinStr = localStorage.getItem('LOCAL_STORAGE_NEW_WINDOW')
if (newWinStr) {
  const newWinObj = JSON.parse(newWinStr)
  const newWinKeys = Object.keys(newWinObj)
  if (Array.isArray(newWinKeys)) {
    newWinKeys.forEach((key) => {
      window[key] = newWinObj[key]
    })
  }
  localStorage.removeItem('LOCAL_STORAGE_NEW_WINDOW')
}

// global plugin
Vue.use(VueDataTable)
Vue.use(VueTable)
Vue.use(VueClipboard)
Vue.use(worldMap)
Vue.use(DragMenu)
Vue.use(Charts)
Vue.use(GridLayout)
Vue.use(VueVirtualScroller) // TAMS
Vue.use(VeeValidate) // TAMS
Vue.use(Quasar, {
  components: All,
  directives: All,
  plugins: All
})

/**
 * Quasar/DataTable BlueMax Store 공유
 *
 * @param app
 * @param isClient
 * @param store
 */
export default ({app, isClient, store}) => {
  Quasar.store.set(store)
  VueDataTable.store.set(store)
  // VueTable.store.set(store) // TAMS 제외
}
